module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABGUlEQVRoQ+1a2w3DIAy092gH6iIdqot0oGYPV5UKSlARfqAC0eXbMT7fgc2DafGPF4+fMgARuRHRg4gufwa1EdGdmZ+ecfcAXgOCTzFvzHyNAhCPg17/MLNLznsGzgXAmxEtIyJySJh3vCoDXocAoM3A1w4MGBOWzTEHohKapXK754CITFG5IwCmKHwAkJaVUYWvGwMA0CgotboBBjAHlL0IJFQmqlczpiSAwAAY0GqlYgcJQUKQ0O9zJPRC6IWUc8O8jCr9ZrPpNjQrAggdk8zAQOiKaTgAq2Sma6cBwHnHpU1ccxnVOkp2kJAxY2CgtR8wJjRsnpZt1+XyZ/SS0nBERgc9AIQqtzHe0jw/TYgwEKrcAQCHxyFvTpOhQHay8TIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/upload_icon.png
// module id = qC/F
// module chunks = 2